import { connect } from 'react-redux';
import Component from './Component';

const mapStateToProps = (state) => ({
    logged: state.account.logged,
    isConnected: state.ezlo.isConnected,
    connectedEzloSerial: state.ezlo.serial,
    isLogging: state.account.isLogging,
    isCustomizationProgressing: state.account.isCustomizationProgressing,
    permissionRole: state.account.data?.PK_PermissionRole,
    ezloPolicies: state.ezloPolicy,
    installerAccessRights: state.installerAccessStore,
});

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    redux: {
        state: stateProps,
    },
});

export default connect(mapStateToProps, null, mergeProps)(Component);
